import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Subscription } from 'rxjs';
import { Manufacturer } from 'src/@omnial/_models/catalog/manufacturer.model';
import { AppSettings } from 'src/app/app.settings';
import { ElfaService } from 'src/app/_services/elfa.service';
import { SwiperOptions } from 'swiper/types';

@Component({
    selector: 'app-elfa-brand-carousel',
    templateUrl: './elfa-brand-carousel.component.html',
    styleUrls: ['./elfa-brand-carousel.component.scss'],
    standalone: false
})
export class ElfaBrandCarouselComponent implements OnInit, OnDestroy {
  @ViewChildren('swiper') swiper: QueryList<ElementRef>;
  public brands: Manufacturer[];
  public config: SwiperOptions = null;
  private subscriptions: Subscription[] = [];

  constructor(private elfaService: ElfaService, public settings: AppSettings) { }

  ngOnInit(): void {
    this.subscriptions.push(this.elfaService.getBrands().subscribe(
      res => {
        this.brands = res;
        this.config = {
          resizeObserver: true,
          slidesPerView: 6,
          spaceBetween: 0,
          grabCursor: false,
          loop: true,
          speed: 500,
          autoplay: true,
          freeMode: {
            enabled: true,
            sticky: true,
          }
        }
        this.swiper?.forEach((swiper) => {
          Object.assign(swiper.nativeElement, this.config);
          swiper.nativeElement.initialize();
        });
      }));
  }


  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach((sub) => { sub.unsubscribe(); });
    }
  }
}
